import 'angular';
import '../../shared/pdfViewer';
import './ApprovalViewController';
import './approvalViewRightPanel/approvalsRightPanel';
import '../approvalService';
import '../listRequests/ListApprovalRequestsController';
import '../listRequests/approvalRequestsList';

angular.module('GorillaBoy.Approvals')
.config(['$routeProvider', ($routeProvider) => {
    $routeProvider
    .when('/approval/:approvalId', {
        templateUrl: './assets/partials/app/layout.html',
        controller: 'ApprovalViewController',
        auth: true
    })
    .when('/awaitingApproval', {
        templateUrl: './assets/partials/app/layout.html',
        controller: 'ListApprovalRequestsController',
        auth: true
    })
    .when('/yourApprovalRequests', {
        templateUrl: './assets/partials/app/layout.html',
        controller: 'ListApprovalRequestsController',
        auth: true
    })
    .when('/takenActionApprovals', {
        templateUrl: './assets/partials/app/layout.html',
        controller: 'ListApprovalRequestsController',
        auth: true
    });


}]);
